var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileSubaccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.09516V3.23801C16.6667 2.18604 15.9205 1.33325 15 1.33325H3.33335C2.41288 1.33325 1.66669 2.18604 1.66669 3.23801V12.7618C1.66669 13.8138 2.41288 14.6666 3.33335 14.6666H15C15.9205 14.6666 16.6667 13.8138 16.6667 12.7618V9.90467V6.09516ZM18.3334 6.09516H13.3334C12.4129 6.09516 11.6667 6.94792 11.6667 7.99992C11.6667 9.05192 12.4129 9.90467 13.3334 9.90467H18.3334V6.09516Z",
    stroke: "#19AE57",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSubaccountIcon);
export default __webpack_public_path__ + "static/media/mobileSubaccountIcon.f67b3b698181c80e3399dcecec1db206.svg";
export { ForwardRef as ReactComponent };